module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/cve-4b5466aca70f2e60938501c3ae5d3371.png";